export default {
  setNewsDetails ({ commit }, payload) {
    commit('setNewsDetails', payload)
  },
  setPopularList ({ commit }, payload) {
    commit('setPopularList', payload)
  }
}
